import { createSlice } from "@reduxjs/toolkit";
import patientStudies from "../../../rtk-apis/patients/patientStudies";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:""

};

const patientStudiesSlice = createSlice({
  name: "patientStudiesSlice",
  initialState,
  reducers: {
    closeStudiesModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(patientStudies.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(patientStudies.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = "SUCCESS";
        state.result = payload;
        state.msg = "Studies fetch successfully";
      })
      .addCase(patientStudies.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default patientStudiesSlice.reducer;
export const { closeStudiesModal } = patientStudiesSlice.actions;
